webpackJsonp([4],{

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global readpage, ReadSpeaker */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(5), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, pubsub, $script) {
		'use strict';
	
		/**
		 * Readspeaker integration
		 * A plugin that integrates with readspeaker.
		 * @exports readspeaker
		 */
		var readspeaker = {
	
			/** Placeholder to contain the readspeaker-link DOM-node. */
			readspeakerLink: null,
	
			/** DOM-node for the readspeaker-player div. */
			readspeakerPlayer: document.getElementById('readspeaker-player'),
	
			/** Boolean to indicate if the readspeaker has been triggered (before the readspeaker-library has been loaded). */
			readspeakerTriggered: false,
	
			/** Delay before re-trigger the readspeaker link if the library wasn't loaded the first time. */
			readspeakerTriggerDelay: 500,
	
			/** Boolean to indicate if the readspeaker close-link click event has been initiated. */
			closeEventInitiated: false,
	
			/** Boolean to indicate if the readspeaker was programmatically closed. */
			programmaticallyClosed: false,
	
	
			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function (el) {
				this.readspeakerLink = el;
				this._initEvents();
				this._loadRadspeakerScript();
			},
	
	
			/**
			 * Init click event.
			 * If readspeaker is expanded, we close it, lse (if the readspeaker-library is loaded) we start readspeaker.
			 * If the library isn't loaded, we set readspeakerTriggered which will retry to start readspeaker after the library has loaded.
			 * @private
			 */
			_initEvents: function () {
				var that = this;
	
				utils.addEventListener(this.readspeakerLink, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
					if (utils.hasClass(that.readspeakerPlayer, 'rsexpanded')) {
						var closeLink = document.querySelector('.rsbtn_closer');
						if (closeLink !== null) {
							that.programmaticallyClosed = true;
							closeLink.click();
						}
					}
					else if (typeof(readpage) !== 'undefined') {
						readpage(that.readspeakerLink.getAttribute('href'), 'readspeaker-player');
	
						if (that.closeEventInitiated === false) {
							that._initCloseEvent();
						}
					} else {
						that.readspeakerTriggered = true;
					}
				});
			},
	
	
			/**
			 * Init click-event of readspeaker close button.
			 * @private
			 */
			_initCloseEvent: function () {
				var that = this,
					readspeakerCloseLink = document.querySelector('.rsbtn_closer');
	
				if (readspeakerCloseLink !== null) {
					utils.addEventListener(readspeakerCloseLink, 'click', function () {
						if (!that.programmaticallyClosed) {
							pubsub.publish('/toggleLink', that.readspeakerLink);
						}
						that.readspeakerLink.focus();
						that.programmaticallyClosed = false;
					});
					this.closeEventInitiated = true;
				}
			},
	
	
			/**
			 * Load the readspeaker library (and if the readspeaker-link already has been click, we trigger it again).
			 * @private
			 */
			_loadRadspeakerScript: function () {
				var that = this,
					rsConf = {
						params: mainConfig.readspeakerUrl
					};
	
				window.rsConf = rsConf; // We store the params where readspeaker want it.
	
				$script.get(rsConf.params, function () {
					try {
						ReadSpeaker.init();
	
						if (that.readspeakerTriggered === true) {
							setTimeout(function () {
								that.readspeakerLink.click();
							}, that.readspeakerTriggerDelay);
						}
					} catch (e) {}
				});
			}
		};
	
	
		return readspeaker;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// partial.4.js